import { render } from "./StepThree.vue?vue&type=template&id=f360b892&scoped=true&ts=true"
import script from "./StepThree.vue?vue&type=script&lang=ts"
export * from "./StepThree.vue?vue&type=script&lang=ts"

import "./StepThree.vue?vue&type=style&index=0&id=f360b892&lang=scss&scoped=true"

import exportComponent from "/Users/martjan/repositories/q-42/virtueel-indisch-monument/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f360b892"]])

export default __exports__